// src/components/UnidadeOrganica/UnidadeOrganicaList.jsx
import React, { useEffect, useState } from 'react';
import { listarUnidadesOrganicas } from '../../services/unidadeOrganicaService';

const UnidadeOrganicaList = () => {
    const [unidades, setUnidades] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await listarUnidadesOrganicas();
            setUnidades(response.data);
        };
        fetchData();
    }, []);

    return (
        <div>
            <h2>Lista de Unidades Orgânicas</h2>
            <ul>
                {unidades.map((unidade) => (
                    <li key={unidade.id}>{unidade.nome} - {unidade.tipo}</li>
                ))}
            </ul>
        </div>
    );
};

export default UnidadeOrganicaList;